/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { v4 as uuid_v4 } from "uuid";

import { IEditor } from "../../IEditor";
import { CodeViewDialog } from "./CodeViewDialog/CodeViewDialog";

export function registerCommands(dc: IEditor): void {
	const commandsSvc = dc.get("commandsService");
	const dialogSvc = dc.get("dialogService");

	commandsSvc.register({
		id: "debugTools.displayCode",
		label: "Display Code",
		args: [
			{
				label: "Language",
				isOptional: false,
				schema: {
					type: "string"
				}
			},
			{
				label: "Source",
				isOptional: false,
				schema: {
					type: "string"
				}
			}
		],
		handler: async (args) => {
			await dialogSvc.open(CodeViewDialog, "debugTools.codeView_" + uuid_v4(), {
				language: args[0] as string,
				codeSource: args[1] as string
			});
		}
	});
}
